module.exports = __webpack_public_path__ + "img/bg_zp_hb.762a4aab.png";